import request from '@/utils/request'

// 点検仕様取得
export function getFoundSelfData(data) {
  return request({
    url: '/api/mitmgkmp/foundSelfData',
    method: 'post',
    data,
  })
}

// 作業実績一覧 更新
export function workResultUpdate(data) {
  return request({
    url: '/api/workingPlanAndResult/workingResultUpdate',
    method: 'post',
    data,
  })
}
